import { BottomSheet } from "../bottom-sheet";

const COOKIES_CONSENT_KEY = "cookies_consent";

class CookiesConsent {
  #sheet = new BottomSheet();

  constructor() {
    this.init = this.init.bind(this);
  }

  #prepareComponent() {
    const isCookiesConsent = Boolean(localStorage.getItem(COOKIES_CONSENT_KEY));
    if (isCookiesConsent) {
      return;
    }

    const modalContainerElement = document.createElement("div");
    modalContainerElement.classList.add("kdl-cookies-consent");
    modalContainerElement.insertAdjacentHTML(
      "beforeend",
      `
        <div class="kdl-cookies-consent__wrapper">
          <p class="kdl-cookies-consent__text">Мы используем <a href=${import.meta.env.VITE_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" class="kdl-cookies-consent__link">cookies</a>, чтобы анализировать, как вы пользуетесь сайтом, рекомендовать полезное и создавать другие удобства на сайте</p>
          <button class="kdl-button kdl-cookies-consent__button kdl-button--size-lg kdl-button--color-brand" type="button">
            <span>Окей</span>
          </button>
        </div>
    `
    );

    const closeButton = modalContainerElement.querySelector<HTMLButtonElement>(".kdl-button");

    closeButton?.addEventListener(
      "click",
      () => {
        localStorage.setItem(COOKIES_CONSENT_KEY, "true");
        this.#sheet.handleSheetHide();
      },
      { once: true }
    );

    this.#sheet.handleSheetShow(modalContainerElement);
  }

  init() {
    this.#prepareComponent();
  }
}

export { CookiesConsent };
